import React from "react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";

const AcceptButtonWithLabel = (props: PurposedButtonProps) => {
  const { colors } = useTheme();

  return (
    <EwaButton2 buttonColor={colors.save} dataCy="accept-button" {...props} />
  );
};

export default AcceptButtonWithLabel;
